import { camelCase, kebabCase, noCase, pascalCase } from 'change-case';
export const formatEntityName = (entityName) => pascalCase(entityName);
export const formatFieldName = (columnName) => camelCase(columnName);
export const formatRoleName = (roleName) => camelCase(roleName);
export const formatPluginName = (pluginType) => kebabCase(pluginType);
export const formatDataType = (dataType) => camelCase(dataType);
export const formatEnumName = (enumName) => camelCase(enumName);
export const formatEnumValue = (enumValue) => camelCase(enumValue);
export const formatRelationType = (relationType) => noCase(relationType);
//# sourceMappingURL=nameFormats.js.map